import { render, staticRenderFns } from "./sosPieChart.vue?vue&type=template&id=91c50bde&"
import script from "./sosPieChart.vue?vue&type=script&lang=js&"
export * from "./sosPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports